type StatusKey = keyof typeof FileHelper.statusMap;
export default class FileHelper {
  static readonly isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (/Macintosh/i.test(navigator.userAgent) && navigator?.maxTouchPoints > 1);

  static readonly openLoadingWindow = (): Window | null => {
    const newWindow = window.open('', '_blank');
    if (newWindow) {
      newWindow.document.title = "Loading Document...";
      const style = newWindow.document.createElement('style');
      style.innerHTML = `
          body { margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; background-color: #f0f2f5; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; }
          .spinner { border: 4px solid rgba(0, 0, 0, 0.1); width: 40px; height: 40px; border-radius: 50%; border-left-color: #5A7890; animation: spin 1s linear infinite; margin: 0 auto 16px; }
          @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
          p { color: #5B7B94; font-size: 16px; font-weight: 500; margin: 0; }
      `;
      newWindow.document.head.appendChild(style);
      
      const div = newWindow.document.createElement('div');
      div.style.textAlign = 'center';
      div.innerHTML = `
        <div class="spinner"></div>
        <p>Loading document...</p>
      `;
      newWindow.document.body.appendChild(div);
    }
    return newWindow;
  };

  static readonly fileToByteArray = async (file: File) => {
    return new Promise<number[]>((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        if (event.target && event.target.result) {
          const arrayBuffer = event.target.result as ArrayBuffer;
          console.log("arrayBuffer", arrayBuffer)
          const uint8Array = new Uint8Array(arrayBuffer);
          resolve(Array.from(uint8Array));
        } else {
          reject(new Error("Error reading file"));
        }
      };

      reader.onerror = () => {
        reject(new Error("Error reading file"));
      };

      reader.readAsArrayBuffer(file);
    });
  };

  static readonly downloadFile = (byteArray: number[], fileName: string): void => {
    const uint8Array = new Uint8Array(byteArray);
    const blob = new Blob([uint8Array]);
    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  static readonly downloadFileByURL = (Url: string, fileName: string): void => {
    const downloadLink = document.createElement('a');
    downloadLink.href = Url;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.target = '_blank';
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  static arrayBufferToBase64(buffer: number[]) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }

  static readonly fileToBase64 = async (file: File) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event: any) => {
        if (event.target && event.target.result) {
          const base64String = btoa(
            new Uint8Array(event.target.result)
              .reduce((data, byte) => data + String.fromCharCode(byte), '')
          );
          resolve(base64String);
        } else {
          reject(new Error("Error reading file"));
        }
      };

      reader.onerror = () => {
        reject(new Error("Error reading file"));
      };

      reader.readAsArrayBuffer(file);
    });
  };
  static status = [0, 7, 8,9, 10,11,12,13,14,17,19]

   static statusMap = {
    0: { className: "pending-status", text: "Pending" },
    1: { className: "approved-status", text: "Approved" },
    2: { className: "reject-status", text: "Denied" },
    3: { className: "reopen-status", text: "Re-open" },
    4: { className: "pending-status", text: "Re-request" },
    6: { className: "approved-status", text: "Approved with stipulations" },
    7: { className: "under-review-status", text: "Pending Committee Vote" },
    8: { className: "approved-with-stipulation-status", text: "Decision Reached – Processing" },
    9: { className: "under-review-status", text: "Appealed" },
    10: { className: "under-review-status", text: "Pending Committee Review" },
    11: { className: "under-review-status", text: "Conflicting votes" },
    12: { className: "pending-status", text: "More Information Requested" },
    13: { className: "appealed-status", text: "Missing Info Received" },
    14: { className: "pending-status", text: "Final Inspection Pending" },
    15: { className: "approved-status", text: "Completed" },
    16: { className: "under-review-status", text: "Withdrawn" },
    17: { className: "under-review-status", text: "Under 3rd Party Review" },
    18: { className: "reject-status", text: "Canceled" },
  };
  
  static submissionStatusFilter = [
    { text: "Pending", value: [0] },
    { text: "Decision Reached – Processing", value: [8] },
    { text: "Appealed", value: [9] },
    { text: "Under Committee Review", value: [7,10,11,19] },
    { text: "More Information Requested", value: [12] },
    { text: "Missing Info Received", value: [13] },
    { text: "Final Inspection Pending", value: [14] },
    { text: "Completed", value: [15] },
    { text: "Withdrawn", value: [16] },
    { text: "Under 3rd Party Review", value: [17] },
    { text: "Canceled", value: [18] },
  ]
  static decisionStatusFilter = [
{ text: "Approved", value: [1] },
 { text: "Denied", value: [2] },
 {text:"Approved with stipulations",value: [6]}
  ]
  static submissionStatus = {
    Pending: 0,
    Approved: 1,
    Denied: 2,
    ReopenRequest: 3,
    Rerequest: 4,
    OnHold: 5,
    ApprovedWithStipulation: 6,
    ForwardToCommittee: 7,
    CommitteeReviewCompleted: 8,
    Appealed: 9,
    PendingMeeting: 10,
    ConflictingVotes: 11,
    Canceled: 18,
    PendingDeveloperServicesVote:19

  };

  static committeeStatuses = [
    this.submissionStatus.ForwardToCommittee,
    this.submissionStatus.PendingMeeting,
    this.submissionStatus.ConflictingVotes,
    this.submissionStatus.PendingDeveloperServicesVote,
  ];
  static submissionStatusMap = {
    0: "Pending",
    1: "Approved",
    2: "Denied",
    3: "Re-Open",
    4: "Re-Request",
    5: "OnHold",
    6: "Approved with Stipulation",
    7: "Under Committee Review",
    8: "Committee Review Completed",
    9: "Appealed",
    10: "Under Committee Review",
    11: "Conflicting Votes",
    18: "Canceled",
    19: "PendingDeveloperServicesVote"
  };

static getDisplaySubmissionStatus = (status: keyof typeof FileHelper.statusMap) => {
  const isCommitteeStatus =this.committeeStatuses.includes(status)

  if (isCommitteeStatus) {
    return "Under Committee Review";
  }

  return FileHelper.statusMap[status]?.text;
};
static readonly getFileNameFromUrl = (url: string): string => {
  if (!url) return "";
  return url.substring(url.lastIndexOf("/") + 1);
};
}
